module.exports = __webpack_public_path__ + "static/media/btn_android_ch.1a61cdb6.png";